import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart7: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-7, statistics, graph"><path d="M3.75 9.25L9.25 9.25L9.25 3.75L3.75 3.75L3.75 9.25ZM3.75 9.25V14.75M3.75 9.25L14.75 9.25V14.75H3.75M3.75 14.75V20.25H20.25V14.75L3.75 14.75ZM3.75 1.75V22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChart7;
